export const SORT = {
    POPULARITY: 'popularity',
    PUBLISHED_ON: 'publishedOn',
}
